import { render, staticRenderFns } from "./goPay.vue?vue&type=template&id=7816e811&scoped=true&"
import script from "./goPay.vue?vue&type=script&lang=js&"
export * from "./goPay.vue?vue&type=script&lang=js&"
import style0 from "./goPay.vue?vue&type=style&index=0&id=7816e811&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7816e811",
  null
  
)

export default component.exports